const DetailView = async () => import('@/views/effort/DetailView.vue')
import type { Props as DetailViewProps } from '@/views/effort/DetailView.vue'
import type { _RouteLocationBase } from 'vue-router'
import type { Props as PM_Convert2PmView_Props } from '@/views/pm/Convert2PmView.vue'

const NotImplementedView = async () => import('@/views/NotImplementedView.vue')

const CaptureView = async () => import('@/views/effort/CaptureView.vue')
const EntryDetailView = async () => import('@/views/effort/EntryDetailView.vue')
const PM_Convert2PmView = async () => import('@/views/pm/Convert2PmView.vue')

interface IdOnlyProps {
  id: number
}

/** @type {import('vue-router').RouteRecordRaw[]} */
export default [
  {
    path: '/effort/:id',
    name: 'effort_details',
    component: DetailView,
    meta: { title: 'Leistungsobjekt' },
    props: (route: _RouteLocationBase): DetailViewProps => {
      return { id: Number(route.params.id) }
    }
  },
  {
    path: '/effort/entry/:id',
    name: 'effort_entry_details',
    component: EntryDetailView,
    meta: { title: 'Leistungsobjekt' },
    props: (route: _RouteLocationBase): DetailViewProps => {
      return { id: Number(route.params.id) }
    }
  },
  {
    path: '/effort/convert2pm/:id',
    name: 'effort_convert_to_planner_entry',
    component: PM_Convert2PmView,
    props: (route: _RouteLocationBase): PM_Convert2PmView_Props => {
      return { id: Number(route.params.id) }
    }
  },
  {
    path: '/effort/split/:id',
    name: 'effort_object_splitting',
    component: NotImplementedView,
    props: (route: _RouteLocationBase): IdOnlyProps => {
      return { id: Number(route.params.id) }
    }
  },
  {
    meta: { title: 'Leistung bearbeiten' },
    path: '/effort/capture/edit/:id',
    name: 'effort_capture_edit',
    component: CaptureView,
    props: (route) => {
      return { edit: Number(route.params.id) }
    }
  },
  {
    meta: { title: 'Leistung duplizieren' },
    path: '/effort/capture/duplicate/:id',
    name: 'effort_capture_duplicate',
    component: CaptureView,
    props: (route) => {
      return { duplicationSource: Number(route.params.id) }
    }
  }
]
